import { CalibrationWithRelatedHardwareReadDto } from '../_generated/api/tagged-hardware'
import ApiModel from './ApiModel'
import { nullableDate } from './ApiLifeCycleModel'
import CalibrationRod from './CalibrationRod'
import Device from './Device'

export default class Calibration extends ApiModel<CalibrationWithRelatedHardwareReadDto> {
    get id() {
        return this.data.id ?? ''
    }

    get aggregateId() {
        return this.data.aggregateId ?? ''
    }

    get sensorId() {
        return this.data.sensorId ?? ''
    }

    get deviceId() {
        return this.data.deviceId ?? ''
    }

    get calibrationRodId() {
        return this.data.calibrationRodId ?? ''
    }

    get tenantId() {
        return this.data.tenantId ?? ''
    }

    get measuredAt() {
        return nullableDate(this.data.measuredAt)
    }

    get measuredBy() {
        return this.data.measuredBy ?? ''
    }

    get temperatureC() {
        return this.data.normalized?.temperatureC
    }

    get resultTofNs() {
        return this.data.normalized?.resultTofNs
    }

    get device() {
        return Device.nullable(this.data.device)
    }

    get deviceLabel() {
        return this.device?.serialNo || this.deviceId
    }

    get calibrationRod() {
        return CalibrationRod.nullable(this.data.calibrationRod)
    }

    get calibrationRodLabel() {
        return this.calibrationRod?.serialNo || this.calibrationRodId
    }
}
